export const COLLECTION_SHOW_TABS = [
  'general',
  'publications',
  'collection',
  'search',
] as const;

export type CollectionShowTab = (typeof COLLECTION_SHOW_TABS)[number];

export const COLLECTION_DEFAULT_TAB: CollectionShowTab = 'general';
